import { Trans, useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import type { McpServer } from './hooks/useMcpServers';

interface DeleteMcpServerDialogProps {
  /** The server pending deletion, or `null` when the dialog is closed. */
  server: McpServer | null;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function DeleteMcpServerDialog({
  server,
  onOpenChange,
  onConfirm,
}: DeleteMcpServerDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={Boolean(server)} onOpenChange={onOpenChange}>
      <DialogContent className="gap-6 sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            {t('common.delete')} {server?.name}
          </DialogTitle>
          <DialogDescription className="min-h-10">
            <Trans i18nKey="mcp.delete_warning" values={[server?.name]} />
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-2">
          <Button variant="outline-neutral" onClick={() => onOpenChange(false)}>
            {t('common.cancel')}
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            {t('common.delete')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
